import * as types from './types';
import { cameraConstraints, FILE_TYPE } from '~/utils/config';

const initialState = {
  defaultSetting: cameraConstraints,
  type: FILE_TYPE.JPEG,
  name: 'default_jpeg',
};

const cameraSettingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_SETTING: {
      const getData = action.payload;
      return {
        ...state,
        defaultSetting: getData.setting,
        type: getData.type,
        name: getData.name,
      };
    }
    case types.RESET_SETTING: {
      return initialState;
    }

    default:
      return state;
  }
};
export default cameraSettingReducer;
